﻿import olMap, { MapOptions } from 'ol/Map';
import { ViewOptions } from 'ol/View';
import View from "./View";

class Map extends olMap {  

    constructor(options?: MapOptions, view?: ViewOptions) {
        super({
            view: new View(view),
            ...(options ?? {})
        });
    }   
}

export default Map;